export default __webpack_public_path__ + "static/media/ceo.3ca78946.jpg";